<app-toaster></app-toaster>

<po-modal 
  #modalNewCount
  p-title="Nova Contagem Avulsa"
  [p-primary-action]="modalPrimaryAction"
  [p-secondary-action]="modalSecondaryAction">
  <div class="po-row">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
      <po-input
        name="newCountDescription"
        p-label="Descrição da Contagem"
        [(ngModel)]="newCountDescription"
        p-placeholder="Digite a descrição"
        [p-maxlength]="50"
        p-required
        p-clean>
      </po-input>
    </div>
  </div>
</po-modal>

<div class="po-row">
  <div class="po-xl-6 po-lg-6 po-md-6 po-sm-12">
    <p class="po-font-title">Contagem Avulsa</p>
  </div>
  <div class="po-xl-6 po-lg-6 po-md-6 po-sm-12 po-text-right">
    <po-button
      p-label="Criar Contagem"
      p-icon="po-icon-plus"
      p-kind="primary"
      (p-click)="createNewCount()">
    </po-button>
  </div>
</div>

<div class="po-row">
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
    <app-scanner (scannedData)="onScannedCode($event)">
    </app-scanner>
  </div>
</div>

<div class="po-row po-mt-2">
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
    <po-container>
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mb-1">
          <span class="po-font-text-large-bold">Lista de contagens</span>
        </div>
      </div>
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <po-select
            name="statusFilter"
            p-label="Status"
            [p-options]="statusFilterOptions"
            [ngModel]="statusFilter"
            (ngModelChange)="onStatusFilterChange($event)">
          </po-select>
        </div>
      </div>
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <div class="count-list-container" (scroll)="onScroll($event)">
            <div class="count-list">
              <ng-container *ngIf="displayCountList.length > 0; else innerNoItems">
                <div class="count-card" *ngFor="let count of displayCountList" (click)="onCountClick(count)">
                  <div class="count-header">
                    <div class="count-title">
                      <div class="count-number">
                        <span class="label">Código:</span>
                        <span class="value po-ml-2">{{ count.countCode }}</span>
                      </div>
                      <div class="count-meta">
                        <span *ngIf="count.conferenceStatus" [ngClass]="getConferenceStatusInfo(count.conferenceStatus).class" class="po-ml-1">
                          <i class="po-icon" [class]="getConferenceStatusInfo(count.conferenceStatus).icon"></i>
                          <span class="po-ml-1">{{ getConferenceStatusInfo(count.conferenceStatus).text }}</span>
                        </span>
                      </div>
                    </div>
                    <div class="count-details">
                      <span class="label">Descrição:</span>
                      <span class="value">{{ count.description }}</span>
                    </div>
                  </div>
                  <div class="count-body">
                    <div class="count-info">
                      <div class="info-row">
                        <span class="label">Data criação:</span>
                        <span class="value">{{ count.createdDate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="loading-more" *ngIf="isLoadingMore">
                  <span class="po-icon po-icon-loading"></span>
                  <span class="po-ml-2">Carregando mais itens...</span>
                </div>
              </ng-container>
              <ng-template #innerNoItems>
                <div class="po-text-center po-mt-4 po-font-text-bold po-text-color-07">Sem itens para o filtro realizado</div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </po-container>
  </div>
</div>
